import { render, staticRenderFns } from "./BongkarMuat.vue?vue&type=template&id=f47696a0&scoped=true&"
import script from "./BongkarMuat.vue?vue&type=script&lang=js&"
export * from "./BongkarMuat.vue?vue&type=script&lang=js&"
import style0 from "./BongkarMuat.vue?vue&type=style&index=0&id=f47696a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47696a0",
  null
  
)

export default component.exports